import React, { ReactEventHandler } from 'react'
import IcoMoon from '@usap/uicomponents/src/components/IcoMoon'
import { ArrowDownIcon } from '@usap/uicomponents/src/components/Icons/default-icons'
import { InfoIconWMO } from '@usap/uicomponents'
import commaSeparetedValue from '@usap/widgets/src/helpers/commaSeparetedValue'
import Style from './style/Subtotal.css'
import constantStyle from './style/constant'
import { SubtotalLeftSide, SubtotalText, SubtotalContainer } from './style/SubtotalWmo.css'

type SubTotalWmoProps = {
  data: any
  showToolTip: boolean
  onToolTipClick: ReactEventHandler<SVGElement>
  textMessage: any
}

const SubTotalWmo: React.FC<SubTotalWmoProps> = ({
  showToolTip,
  textMessage,
  onToolTipClick,
  data,
}) => {
  const subTotal = data.estSubTotal ? parseFloat(data.estSubTotal) : parseFloat(data.subTotal)

  return (
    <SubtotalContainer>
      {showToolTip && (
      <Style.TooltipContainer
        id="tooltiptext"
        align="center"
        justify="center"
        height="102px"
        // @ts-ignore
        border={constantStyle.tooltipBorder}
        background="white"
      >
        <Style.TooltipText
          dangerouslySetInnerHTML={textMessage}
        />
        <Style.TooltipPointer>
          <IcoMoon icon={ArrowDownIcon} color="white" size="40px" />
        </Style.TooltipPointer>
      </Style.TooltipContainer>
      )}

      <SubtotalLeftSide>
        <SubtotalText size="small">
          Subtotal:
        </SubtotalText>
      </SubtotalLeftSide>

      <Style.InfoIcon id="subtotaltooltipicon">
        <IcoMoon
          icon={InfoIconWMO}
          width="20px"
          height="20px"
          color="#3E3E47"
          onClick={onToolTipClick}
        />
      </Style.InfoIcon>

      <SubtotalText size="small" color="dark-2" data-testid='cart-summary-subtotal'>
        $
        {commaSeparetedValue(subTotal)}
      </SubtotalText>
    </SubtotalContainer>
  )
}

export default SubTotalWmo
